module.exports = __webpack_public_path__ + "img/reglettes.9c2814dc.jpg";